import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const addContactAPI = createAsyncThunk('client',async(value)=>{
    try {
        // const url = 'http://localhost:3300/contact/post';
        const url = 'https://www.ns6.microcodepgmt.com/contact/post';
        const response = await fetch(url,{
        method:'POST',
        headers:{
            'Content-Type':'application/json'
        },
        body:JSON.stringify({
            name:value.name,
            mobile:value.mobile,
            email:value.email,
            description:value.description,
        })
    })
    const res = await response.json();
    return res;
    } catch (error) {
        alert(error);
        console.log('The Error is ',error);
    }
}); 

const addContactSlice = createSlice({
    name:'addContact',
    initialState:{
        loading:false,
        addContact:[],
        sucessMessage:"",
        error:''
    },
    extraReducers:(builder)=>{
        builder.addCase(addContactAPI.pending,(state,action)=>{
            state.loading=true;
            state.sucessMessage = ""
        })
        builder.addCase(addContactAPI.fulfilled,(state,action)=>{
            state.loading=false;
            state.sucessMessage=action.payload.message
            state.addContact=action.payload;
        })
        builder.addCase(addContactAPI.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.error.message;
            state.sucessMessage=action.payload.message
        })
    }
})
export default addContactSlice;